<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <div class="row align--center">
            <div class="flex md3">
              <va-input
                :value="searchInput"
                placeholder="Nom, Contact, Courriel, Ville..."
                removable
                @input="searchTables"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>
            <div class="flex xs12 md8">
              <div class="row row-inside">
                <va-button-toggle
                  outline
                  class="toggle--align"
                  v-model="typeOption"
                  :options="options_type"
                />

                <va-button-toggle
                  outline
                  class="toggle--align"
                  v-model="showinactive"
                  :options="options"
                />
                <h5
                  class="selection-nb-title"
                  :style="{ color: this.$themes.primary }"
                >
                  Sélectionnés :
                  {{
                    listtype === "personnes"
                      ? filteredDataContacts.length
                      : filteredDataPartenaires.length
                  }}
                </h5>
                <va-popover message="Rafraichir" placement="top">
                  <va-button
                    class="selection-refresh"
                    flat
                    large
                    color="primary"
                    icon="fa fa-refresh"
                    @click="loadList()"
                  />
                </va-popover>
              </div>
            </div>
            <div class="flex xs6 md1">
              <va-input
                class="centered toggle--align"
                :value="perPage"
                :label="$t('tables.perPage')"
                @input="changePageNumber"
              ></va-input>
            </div>
          </div>
          <va-data-table
            v-if="listtype === 'personnes'"
            class="va-table--hoverable va-table--stripped custom-table"
            :fields="fields_contacts"
            :data="filteredDataContacts"
            :no-data-label="$t('poissonnierTable.empty')"
            :per-page="parseInt(perPage)"
            @row-clicked="openPartenaire"
            clickable
          ></va-data-table>
          <va-data-table
            v-if="listtype === 'entites'"
            class="va-table--hoverable va-table--stripped custom-table"
            :fields="fields_partenaires"
            :data="filteredDataPartenaires"
            :no-data-label="$t('poissonnierTable.empty')"
            :per-page="parseInt(perPage)"
            @row-clicked="openPartenaire"
            clickable
          >
            <template slot="verification" slot-scope="props"></template>
            <template slot="contact" slot-scope="props">
              <p>
                {{ props.rowData.titre + " " + props.rowData.contact_nom + " "
                }}{{ props.rowData.prenom ? " " + props.rowData.prenom : "" }}
              </p>
            </template>
            <template slot="journal" slot-scope="props"></template>
            <template slot="actions" slot-scope="props">
              <va-popover
                v-if="canDelete"
                message="Supprimer le partenaire"
                placement="left"
              >
                <va-button
                  flat
                  small
                  color="primary"
                  icon="fa fa-trash"
                  @click="deletePartenaire(props.rowData, 2)"
                />
              </va-popover>
            </template>
          </va-data-table>
          <div
            class="flex md1 offset--md11"
            v-if="canCreate && listtype === 'entites'"
          >
            <div class="row row-inside">
              <va-button class="create-button" @click="createPartenaire">
                <va-icon size="30px" name="fa fa-plus" />
              </va-button>
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <dashboard-fiche-partenaire
      v-model="showFichePartenaire"
      :idpartenaire="idpartenaire"
      @update="updatePartenaire"
      @updateContacts="loadListContacts"
    />
    <dashboard-create-partenaire
      v-model="showCreatePartenaire"
      @create="addPartenaire"
    />
    <va-modal
      class="modal"
      title="Suppression du partenaire"
      v-model="showConfirmDelete"
      :message="deleteModalMessage"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deletePartenaire(partenaireToDelete, 1)"
      v-on:cancel="deletePartenaire(null, 0)"
      @update="updatePartenaire"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, debounce, findIndex, deburr } from "lodash";
import DashboardFichePartenaire from "./DashboardFichePartenaire";
import DashboardCreatePartenaire from "./DashboardCreatePartenaire";

export default {
  props: ["listtype", "idpartenaire"],
  components: {
    DashboardFichePartenaire,
    DashboardCreatePartenaire,
  },
  data() {
    return {
      canDelete: this.$store.getters.user.suppression_partenaires,
      isaction: false,
      partenaireToDelete: null,
      deleteModalMessage: "Supprimer le partenaire?",
      showConfirmDelete: false,
      canCreate: this.$store.getters.user.creation_partenaires,
      showFichePartenaire: false,
      showCreatePartenaire: false,
      searchInput: "",
      contactList: [],
      partenaireList: [],
      perPage: 25,
      options_type: [
        { label: "Contacts", value: "contacts" },
        { label: "Entités", value: "partenaires" },
      ],
      typeOption: "contacts",
      options: [
        { label: "Actives", value: "active" },
        { label: "Toutes", value: "all" },
        { label: "Inactives", value: "inactive" },
      ],
      showinactive: "active",
    };
  },
  created: function () {
    // check if recreated
    console.log("created");
  },
  methods: {
    deletePartenaire(partenaire, action) {
      this.isaction = true;
      //prepare and show modal
      if (action === 2) {
        this.deleteModalMessage =
          "Voulez vous supprimer : " +
          partenaire.nom +
          " et toutes les données associées?";
        this.partenaireToDelete = cloneDeep(partenaire);
        this.showConfirmDelete = true;
      } else if (action === 0) {
        //annulation de la suppression
        this.partenaireToDelete = null;
        this.showConfirmDelete = false;
      } else if (action === 1) {
        axios
          .delete("/api/partenaire", {
            data: { idpartenaire: this.partenaireToDelete.idpartenaire },
          })
          .then((res) => {
            this.loadList();
            this.launchEpicmaxToast("Entreprise supprimée");
          })
          .catch((err) => {
            console.log(err);
            this.launchEpicmaxToast("Erreur lors de la suppression");
          });
      }
    },
    createPartenaire() {
      this.showCreatePartenaire = true;
    },
    updatePartenaire() {},
    addPartenaire(payload) {
      this.loadList();
      this.$router.push({
        name: "contacts",
        params: { listtype: this.listtype, idpartenaire: payload },
      });
    },
    updatePartenaire(payload) {
      this.loadList();
    },
    searchTables: debounce(function (searchInput) {
      this.searchInput = searchInput;
    }, 400),
    changePageNumber: debounce(function (perPage) {
      var n = Math.floor(Number(perPage));
      if (n !== Infinity && String(n) === perPage && n >= 0) {
        this.perPage = perPage;
      } else {
        this.perPage = "25";
      }
    }, 400),
    openPartenaire(row) {
      if (!this.isaction) {
        this.$router.push({
          name: "contacts",
          params: { listtype: this.listtype, idpartenaire: row.idpartenaire },
        });
        this.showFichePartenaire = true;
      }
      this.isaction = false;
    },
    async loadList() {
      try {
        await this.loadListContacts();
        await this.loadListPartenaires();
        this.launchEpicmaxToast("Listes mises à jour");
      } catch (error) {}
    },
    async loadListContacts() {
      try {
        let res = await axios.get("/api/partenaires/contacts");
        this.contactList = res.data;
        console.log(this.contactList);
      } catch (err) {
        this.launchEpicmaxToast("Erreur lors du chargement");
      }
    },
    async loadListPartenaires() {
      try {
        let res = await axios.get("/api/partenaires/liste");
        this.partenaireList = res.data;
      } catch (err) {
        this.launchEpicmaxToast("Erreur lors du chargement");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  watch: {
    typeOption(newvalue) {
      if (
        newvalue === "contacts" &&
        this.listtype &&
        this.listtype !== "personnes"
      ) {
        this.$router.push({
          name: "contacts",
          params: { listtype: "personnes" },
        });
      } else if (
        newvalue === "partenaires" &&
        this.listtype &&
        this.listtype !== "entites"
      ) {
        this.$router.push({
          name: "contacts",
          params: { listtype: "entites" },
        });
      }
    },
    listtype: {
      immediate: true,
      handler(newvalue) {
        if (newvalue === "personnes") {
          this.loadListContacts();
          this.typeOption = "contacts";
        } else if (newvalue === "entites") {
          this.loadListPartenaires();
          this.typeOption = "partenaires";
        }
      },
    },
    showFichePartenaire(newvalue) {
      if (!newvalue) {
        this.$router.push({
          name: "contacts",
          params: { listtype: this.listtype, idpartenaire: null },
        });
      }
    },
    idpartenaire: {
      immediate: true,
      handler(newvalue) {
        if (newvalue) {
          this.showFichePartenaire = true;
        } else {
          this.showFichePartenaire = false;
        }
      },
    },
  },
  computed: {
    filteredDataContacts() {
      let filteredData = this.contactList;

      if (
        (!this.searchInput || this.searchInput < 1) &&
        this.showinactive === "all"
      ) {
        return filteredData;
      }

      return filteredData.filter((item) => {
        let boolcond = true;

        if (this.showinactive === "active" && item.fin_activite) {
          boolcond = false;
        }

        if (this.showinactive === "inactive" && !item.fin_activite) {
          boolcond = false;
        }

        if (this.searchInput && this.searchInput.length >= 1) {
          let searchInput = deburr(this.searchInput).toLowerCase();
          let tmpBoolCond = false;
          Object.keys(item).forEach(function (key, index) {
            if (
              item[key] &&
              deburr(item[key]).toLowerCase().includes(searchInput)
            ) {
              tmpBoolCond = true;
            }
          });

          boolcond = boolcond && tmpBoolCond;
        }

        return boolcond;
      });
    },
    fields_contacts() {
      return [
        {
          name: "nom",
          title: "Nom",
          sortField: "nom",
          width: "10%",
        },
        {
          name: "prenom",
          title: "Prénom",
          sortField: "prenom",
          width: "10%",
        },
        {
          name: "adresse",
          title: "Adresse",
          sortField: "adresse",
          width: "15%",
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "code_postal",
          width: "5%",
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville",
          width: "10%",
        },
        {
          name: "societe",
          title: "Société",
          sortField: "societe",
          width: "10%",
        },
        {
          name: "note",
          title: "Commentaires",
          width: "20%",
        },
        {
          name: "__slot:journal",
          title: "Journal",
          width: "10%",
        },
        {
          name: "__slot:actions",
          title: "Action",
          width: "10%",
        },
      ];
    },

    filteredDataPartenaires() {
      let filteredData = this.partenaireList;

      if (
        (!this.searchInput || this.searchInput < 1) &&
        this.showinactive === "all"
      ) {
        return filteredData;
      }

      return filteredData.filter((item) => {
        let boolcond = true;

        if (this.showinactive === "active" && item.fin_activite) {
          boolcond = false;
        }

        if (this.showinactive === "inactive" && !item.fin_activite) {
          boolcond = false;
        }

        if (this.searchInput && this.searchInput.length >= 1) {
          let searchInput = deburr(this.searchInput).toLowerCase();
          let tmpBoolCond = false;
          Object.keys(item).forEach(function (key, index) {
            if (
              item[key] &&
              deburr(item[key]).toLowerCase().includes(searchInput)
            ) {
              tmpBoolCond = true;
            }
          });

          boolcond = boolcond && tmpBoolCond;
        }

        return boolcond;
      });
    },
    fields_partenaires() {
      return [
        {
          name: "__slot:verification",
          title: "",
          width: "5%",
        },
        {
          name: "nom",
          title: "Nom",
          sortField: "nom",
          width: "10%",
        },
        {
          name: "__slot:contact",
          title: "Contact principal",
          width: "15%",
        },
        {
          name: "adresse",
          title: "Adresse",
          sortField: "adresse",
          width: "15%",
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "prenom",
          width: "5%",
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville",
          width: "10%",
        },
        {
          name: "__slot:journal",
          title: "Journal",
          width: "10%",
        },
        {
          name: "__slot:actions",
          title: "Action",
          width: "10%",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-table {
  font-size: 1rem;
  line-height: 1rem;
}

.toggle--align {
  position: relative;
  top: -0.4em;
}

.selection-refresh {
  position: relative;
  top: -0.6em;
}
.selection-nb-title {
  position: relative;
  top: 0.4em;
}
</style>
